export default {
	Home: 'Home',
	Login: 'Login',
	ChangePassword: 'ChangePassword',
	NotificationLanding: 'NotificationLanding',

	Dashboard: 'Dashboard',

	OrdersList: 'OrdersList',
	OrdersKanban: 'OrdersKanban',
	CreateOrder: 'CreateOrder',
	OrderDetails: 'OrderDetails',
	OrdersReviews: 'OrdersReviews',
	DiscountList: 'DiscountList',
	DiscountDetails: 'DiscountDetails',

	BusinessMenu: 'BusinessMenu',
	ToppingsList: 'ToppingsList',
	MyBusinesses: 'MyBusinesses',

	TopProducts: 'TopProducts',
	DynamicReports: 'DynamicReports',

	FinanceOverview: 'FinanceOverview',
	InvoiceDetails: 'InvoiceDetails',
	Payments: 'Payments',
	Purchases: 'Purchases',

	NotFoundView: 'NotFoundView',
};
